import React from 'react';
import './Teaching.css';
import HeroCarousel from '../../components/HeroCarousel';
import { useContent } from '../../context/ContentContext';

const Teaching = () => {
  const { teaching, siteContent } = useContent();
  const sortedTeaching = [...teaching].sort((a, b) => a.sortOrder - b.sortOrder);

  return (
    <>
      <HeroCarousel page="Pedagogy" />
      <div className="publications">
        <h2>{siteContent.pedagogy_heading}</h2>
        {sortedTeaching.map((entry) => (
          <div className="pub-content" key={entry.id || `teaching-${entry.sortOrder}`}>
            {entry.description}
          </div>
        ))}
      </div>
    </>
  );
};

export default Teaching;
